module.exports = __webpack_public_path__ + "img/img8.c6f88d86.svg";